import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppState } from '@core/store';
import { currentUser } from '@core/store/selectors/auth.selectors';
import { Store } from '@ngrx/store';
import { first, map, Observable, of, switchMap, take } from 'rxjs';
import { InterceptStrategy } from './InterceptStrategy';

@Injectable({ providedIn: 'root' })
export class DmsInterceptStrategy implements InterceptStrategy {
	constructor(private storeAppState: Store<AppState>) {} // private readonly sgdSecurityService: SgdSecurityService

	isRefreshToken = true;

	isIntercepted(req: HttpRequest<any>): boolean {
		return req.url.includes('api-cluster-dms.sumax.pe');
	}

	additionalParams(): Observable<Record<string, unknown>> {
		return this.storeAppState.select(currentUser).pipe(
			first(),
			map(
				(user) =>
					({
						nroDocumento: user?.sciEmpresa?.nroDocumento || '',
					} as Record<string, unknown>)
			)
		);
	}

	getHttpRequest(
		req: HttpRequest<any>,
		additionalParams?: Record<string, unknown>
	): HttpRequest<any> {
		return req.clone({
			setHeaders: {
				Authorization: `Bearer ${additionalParams?.token || ''}`,
				nroDocumento: additionalParams?.nroDocumento?.toString() || '',
			},
		});
	}

	isPosibleTokenExpired(error: HttpErrorResponse): boolean {
		return false;
	}

	refreshToken(): Observable<Record<string, unknown>> {
		return this.storeAppState.select(currentUser).pipe(
			map((user) => user?.sciEmpresa?.nroDocumento),
			take(1),
			switchMap((nroDocumento) => {
				return of({});
				// Usarlo cuando se necesite DMS
				// return this.sgdSecurityService.loginDms(nroDocumento).pipe(
				// 	map((res: any) => ({
				// 		token: res.token,
				// 		nroDocumento: nroDocumento,
				// 	}))
				// );
			})
		);
	}
}
